export default __webpack_public_path__ + "static/airflow-8536df4e6f5d9e1322405df332dda6a2.png";